import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import 'flowbite'
import { Drawer } from 'flowbite'
import Swiper from 'swiper'
import { formatMoney } from '@shopify/theme-currency'
import {
  Navigation,
  EffectFade,
  Keyboard,
  Pagination,
  Controller,
  Autoplay,
  Thumbs,
} from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/effect-fade'
import 'swiper/css/pagination'
import 'swiper/css/controller'
import 'swiper/css/keyboard'
import 'swiper/css/autoplay'
import 'swiper/css/thumbs'

const $el = document.querySelector('#drawer-cart')

const options = {
  placement: 'right',
  backdrop: true,
  backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30',
}

const drawerCart = new Drawer($el, options)

const locale = 'es-CL'
const currency = 'CLP'
const formattedNumber = new Intl.NumberFormat(locale, {
  currency: currency,
  style: 'currency',
  minimumFractionDigits: 0,
})

window.Alpine = Alpine
window.drawerCart = drawerCart
window.Swiper = Swiper
window.Navigation = Navigation
window.EffectFade = EffectFade
window.Keyboard = Keyboard
window.Pagination = Pagination
window.Controller = Controller
window.Autoplay = Autoplay
window.Drawer = Drawer
window.Thumbs = Thumbs
window.formatMoney = formatMoney
window.formattedNumber = formattedNumber

Alpine.plugin(collapse)

Alpine.start()
